/* eslint-disable */
// import React from "react";
// import "./InfoCards.css";

// const InfoCards = ({ cards }) => {
//   return (
//     <div className="cards-container">
//       {cards.map(({ title, children }, index) => (
//         <div key={index} className="card">
//           <div className="card-header">{title}</div>
//           <div className="card-body">{children}</div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default InfoCards;

// ########### new #################
// import React from "react";

// const InfoCards = ({ cards }) => {
//   return (
//     <div className="container">
//       <div className="row g-3">
//         {cards.map(({ title, children }, index) => (
//           <div key={index} className="col-12 col-sm-2 col-lg-2">
//             <div className="card shadow-sm h-100">
//               <div className="card-header bg-primary text-white fw-semibold">
//                 {title}
//               </div>
//               <div className="card-body">
//                 {children}
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default InfoCards;

// import React from "react";

// const InfoCards = ({ cards }) => {
//   return (
//     <div className="row justify-content-start gx-2 gy-2">
//       {cards.map(({ title, children }, index) => (
//         <div key={index} className="col-12 col-sm-2 col-md-4">
//           <div className="card shadow-sm h-100">
//             <div className="card-header bg-primary text-white text-center fw-semibold">
//               {title}
//             </div>
//             <div className="card-body">
//               {children}
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default InfoCards;
// ####################################################
// import React, { useState } from 'react';
// import './InfoCards.css'; // Optional for styles

// const InfoCards = ({ tabs }) => {
//   const [activeTab, setActiveTab] = useState(tabs[0].label);

//   return (
//     <div className="d-flex">
//       {tabs.map((tab) => (
//         <div
//           key={tab.label}
//           className={`tab-card p-3 text-white fw-bold text-center flex-fill ${
//             activeTab === tab.label ? 'tab-active' : ''
//           }`}
//           style={{ cursor: 'pointer', backgroundColor: '#1DA1CE' }}
//           onClick={() => setActiveTab(tab.label)}
//         >
//           {tab.label}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default InfoCards;

import React from 'react';
import './InfoCards.css';

const InfoCards = ({ title, value }) => {
  return (
    <div className="stat-card text-center">
      <div className="stat-card-header">{title}</div>
      <div className="stat-card-value">{value}</div>
    </div>
  );
};

export default InfoCards;



